import { Component, OnInit } from '@angular/core';
import { STATIC_VALUE } from './../../shared/configuration/static.value';
import { LayoutService } from '../../shared/services/layout.service';
import { PlantMapService } from '../services/plant-map.service';
import { PopupService } from '../../shared/services/pop-up.service';

@Component({
    selector: 'plantmap-earthwork-details',
    templateUrl: 'earthwork-details.component.html'
})

export class PlantmapEarthworkDetailsComponent implements OnInit{

    RB_Purpose: string;
    vError: boolean;
    vShow: boolean;
    editMode: boolean = false;

    constructor(
        private _layoutService: LayoutService,
        private _plantMapService: PlantMapService,
        private _popupService: PopupService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('plantmap-earthwork-details');
        this._plantMapService.resetPlantMapData();
        this._plantMapService.resetEarthworkDetails();
        this.vShow = this._layoutService.tandc;
        this._plantMapService.LoadCompany();

    }

    isDisableSubmit(){
        return this._plantMapService.isDisableEarthworkDetailsData();
    }

    getEarthworkDetailsData(){
        return this._plantMapService.getEarthworkDetailsData();
    }

    submitEarthworkDetail(){
        this._plantMapService.saveEarthworkDetails();
    }

    PurposeOfPlanMap()
    {
        return STATIC_VALUE.PLANMAP_PURPOSE;
    }

    radiochangeHandler(event: any){
        this.RB_Purpose = event.value;
    }

    Purpose()
    {
        return STATIC_VALUE.PLANMAP_PURPOSE;
    }

    InvoiceGenTest()
    {
        console.log("Line 58");
        this._plantMapService.loadInvoive();
    }

    openStatusConfirmationPopup(projecttitle, maincontractor, loc,rb_purpose, purpose){
        if (rb_purpose == "3" && (purpose.trim() == ""|| purpose.trim() == undefined))
        {
            this.vError = true;
            return this._plantMapService.isDisablePurpose();                          
        }
        else {
        this._plantMapService.LoadPopup(projecttitle,maincontractor,loc, rb_purpose, purpose).then(
            (resolve) => {
                let data = resolve['data'];
               //console.log(data);
               //console.log(projecttitle, maincontractor, loc,rb_purpose, purpose);
               //console.log(data.status[0].status);

                if(data.status[0].status == 2) {
                    this._popupService.openPopup( 'confirmation', {
                        title: 'Notice',
                        message: STATIC_VALUE.PRP_REQUEST_VALIDATION_LOGIN,
                        buttons: {
                            OK: {
                                text: 'OK',
                                function: () => {
                                    this._popupService.closeConfirmationPopup();
                                }
                            }
                        }}
                    );
                } 
                else if(data.status[0].status == 1) {
                    this._popupService.openPopup( 'confirmation', {
                        title: 'Notice',
                        message: STATIC_VALUE.PRP_REQUEST_VALIDATION_MSG,
                        buttons: {
                            CANCEL: {
                                text: 'No',
                                function: () => {
                                    this._popupService.closeConfirmationPopup();
                                }
                            },
                            OK: {
                                text: 'Yes',
                                function: () => {
                                    if(this.isDisableSubmit()) {
                                        return this._plantMapService.isDisableEarthworkDetailsData();
                                    } else {
                                        this._plantMapService.saveEarthworkDetails();
                                    }
                                    this._popupService.closeConfirmationPopup();
                                }
                            }
                        }}
                    );
                }
                else {
                   if(this.isDisableSubmit()) {
                        return this._plantMapService.isDisableEarthworkDetailsData();
                    } else {
                        this._plantMapService.saveEarthworkDetails();
                    }
                    this._popupService.closeConfirmationPopup();
                }
            },
            (reject) => {

            }           
            
        );
    }
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/earthwork-details.component.ts